import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import PettyCashDocument from "./PettyCashDocument";
import axios from "axios";

const PettyCashPrint = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const location = useLocation();
  const printPCNo = location.state?.pcPrintData || "-";
  const [pcPrintDataFromAPI, setPCPrintDataFromAPI] = useState([]);
  const [sumOfAmounts, setSumOfAmounts] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (printPCNo) fetchPaymentReport();
  }, [printPCNo]);

  const fetchPaymentReport = async () => {
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      if (!apiPaths[0]?.API_CONFIG) {
        console.error("API config missing in localStorage.");
        return;
      }

      const apiUrl = `${apiPaths[0].API_CONFIG}/api/CRMReportGenerator/${COMPANY_CODE}/PYMT_PRINT/${printPCNo}/${DEPARTMENT}/PC/-/-/-/-`;

      const { data } = await axios.get(apiUrl);
      console.log("PC Print Data in PCPrint:", data);
      setPCPrintDataFromAPI(data || []);
      setSumOfAmounts(
        data.reduce((sum, item) => sum + (Number(item.FCAMT) || 0), 0),
      );

      // console.log("Total FCAMT sum:", sumOfAmounts);
    } catch (err) {
      console.error("Error fetching petty cash print data:", err);
    }
  };

  const onBack = () => {
    navigate("/pettyCashView");
  };

  return (
    <div className="mx-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-normal my-4">Petty Cash Print Preview</h2>
        <button
          onClick={onBack}
          className="mb-3 relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
        >
          <span className="mr-10">Back</span>
          <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
            <FaArrowLeft className="text-gray-600" />
          </div>
        </button>
      </div>

      <div className="flex flex-col items-center h-screen">
        {pcPrintDataFromAPI.length > 0 ? (
          <>
            <div className="w-full h-screen border border-gray-300 mb-4">
              <PDFViewer width="100%" height="100%">
                <PettyCashDocument
                  pcPrintDataFromAPI={pcPrintDataFromAPI}
                  printPCNo={printPCNo}
                  sumOfAmounts={sumOfAmounts}
                />
              </PDFViewer>
            </div>

            <div className="mt-4 mb-6">
              <PDFDownloadLink
                document={
                  <PettyCashDocument
                    pcPrintDataFromAPI={pcPrintDataFromAPI}
                    printPCNo={printPCNo}
                  />
                }
                fileName={`PettyCash_${printPCNo}.pdf`}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                {({ loading }) =>
                  loading ? "Preparing document..." : "Download PDF"
                }
              </PDFDownloadLink>
            </div>
          </>
        ) : (
          <p className="text-gray-600 mt-10">Loading petty cash data...</p>
        )}
      </div>
    </div>
  );
};

export default PettyCashPrint;
